import { Check, Loader2 } from "lucide-react";

// LP3 – Hochwertige „KI-Arbeitskarte": links denkendes Strichmännchen,
// rechts mitlaufende Fortschritts-Checkliste. Minimalistisch, slate/dunkelblau.
// BLOCK3 · Insider-Begriff „Welt" entfernt (Erstbesucher kennt ihn nicht).
export default function KiArbeitskarte({ steps, doneCount, checking, title = "CLartext bereitet Ihre Dokumentation vor …" }) {
  return (
    <div className="ki-card" data-testid="lp3-loader">
      <div className="ki-stage" aria-hidden="true">
        <svg viewBox="0 0 190 130" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <g className="fig">
            <circle cx="48" cy="56" r="13" />
            <line x1="48" y1="69" x2="48" y2="100" />
            <path d="M48 79 L36 74 L41 61" />
            <path d="M48 80 L60 86" />
            <path d="M48 100 L39 121" />
            <path d="M48 100 L57 121" />
          </g>
          <circle className="dot1" cx="70" cy="45" r="2.4" fill="currentColor" stroke="none" />
          <circle className="dot2" cx="80" cy="38" r="3" fill="currentColor" stroke="none" />
          <circle className="dot3" cx="91" cy="31" r="3.6" fill="currentColor" stroke="none" />
          <g className="bulb">
            <circle cx="93" cy="24" r="10" fill="#fff" />
            <path d="M89 24 q4 -5 8 0" strokeWidth="2" />
            <line x1="89" y1="35" x2="97" y2="35" />
            <line x1="90" y1="38.5" x2="96" y2="38.5" />
            <g className="glow" strokeWidth="2.4">
              <line x1="93" y1="5" x2="93" y2="10" />
              <line x1="110" y1="10" x2="106" y2="14" />
              <line x1="76" y1="10" x2="80" y2="14" />
              <line x1="114" y1="24" x2="109" y2="24" />
              <line x1="72" y1="24" x2="77" y2="24" />
            </g>
          </g>
          <g className="doc">
            <rect x="120" y="40" width="58" height="74" rx="8" fill="#fff" />
            <path className="dchk dchk1" d="M129 58 l4 4 l7 -8" />
            <line className="dline dl1" x1="146" y1="58" x2="170" y2="58" />
            <path className="dchk dchk2" d="M129 78 l4 4 l7 -8" />
            <line className="dline dl2" x1="146" y1="78" x2="170" y2="78" />
            <path className="dchk dchk3" d="M129 98 l4 4 l7 -8" />
            <line className="dline dl3" x1="146" y1="98" x2="170" y2="98" />
          </g>
        </svg>
      </div>

      <div className="ki-status">
        <div className="ki-status-title" data-testid="lp3-loader-title">{title}</div>
        <ul className="ki-steps" data-testid="lp3-loader-steps">
          {steps.map((label, i) => {
            const done = i < doneCount;
            const active = i === doneCount;
            const isLast = i === steps.length - 1;
            const showChecking = active && checking && isLast;
            const cls = done ? "done" : active ? "active" : "pending";
            return (
              <li key={i} className={`ki-step ${cls}${showChecking ? " checking" : ""}`} data-testid={`lp3-step-${i}`}>
                <span className="ic">
                  {done ? <Check size={14} /> : active ? <Loader2 size={14} className="spin" /> : <span className="dotmark" />}
                </span>
                <span className="lbl">{showChecking ? "Qualität wird geprüft …" : label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
